// extracted by mini-css-extract-plugin
module.exports = {"header-bg-image":"f","headerBgImage":"f","header-bg":"g","headerBg":"g"};